(() => {
  const padNumber = (value) => String(value).padStart(2, "0");

  const enhanceStaticPage = (root) => {
    if (!root || root.dataset.enhanced === "true") return;

    const source = root.querySelector("[data-static-source]");
    const accordionList = root.querySelector("[data-static-accordions]");
    const toc = root.querySelector("[data-static-toc]");
    const tocList = root.querySelector("[data-static-toc-list]");
    const mobileNavContent = root.querySelector(".bl-static__mobile-nav-content");
    const policyNav = root.querySelector(":scope > .bl-static__layout .bl-static__sidebar > .bl-static__policy-nav");

    if (mobileNavContent && policyNav) {
      mobileNavContent.append(policyNav.cloneNode(true));
    }

    if (!source || !accordionList) {
      root.dataset.enhanced = "true";
      return;
    }

    const wrappedContent =
      source.children.length === 1 &&
      /^(DIV|SECTION)$/.test(source.firstElementChild.tagName) &&
      source.firstElementChild.querySelector("h2, h3");
    const contentRoot = wrappedContent ? source.firstElementChild : source;
    const nodes = Array.from(contentRoot.childNodes);
    const groups = [];
    let currentGroup = null;

    nodes.forEach((node) => {
      const isHeading = node.nodeType === Node.ELEMENT_NODE && /^(H2|H3)$/.test(node.tagName);

      if (isHeading) {
        if (node.tagName === "H2" || !currentGroup) {
          currentGroup = {
            title: node.textContent.trim(),
            nodes: [],
          };
          groups.push(currentGroup);
        } else {
          node.classList.add("bl-static__nested-heading");
          currentGroup.nodes.push(node);
        }
      } else if (currentGroup) {
        currentGroup.nodes.push(node);
      } else if (node.nodeType !== Node.TEXT_NODE || node.textContent.trim()) {
        if (!groups.length) {
          currentGroup = { title: "Overview", nodes: [] };
          groups.push(currentGroup);
        }
        currentGroup.nodes.push(node);
      }
    });

    if (!groups.length) {
      root.dataset.enhanced = "true";
      return;
    }

    groups.forEach((group, index) => {
      const details = document.createElement("details");
      const sectionNumber = padNumber(index + 1);
      const sectionId = `section-${index + 1}`;
      details.className = "bl-static__accordion";
      details.id = sectionId;
      if (index === 0) details.open = true;

      const summary = document.createElement("summary");
      const number = document.createElement("span");
      const title = document.createElement("span");
      const chevron = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      const chevronPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

      number.className = "bl-static__accordion-number";
      number.setAttribute("aria-hidden", "true");
      number.textContent = sectionNumber;
      title.className = "bl-static__accordion-title";
      title.textContent = group.title;
      chevron.classList.add("bl-static__accordion-chevron");
      chevron.setAttribute("aria-hidden", "true");
      chevron.setAttribute("viewBox", "0 0 16 10");
      chevronPath.setAttribute("d", "m2 2 6 6 6-6");
      chevron.append(chevronPath);
      summary.append(number, title, chevron);

      const panel = document.createElement("div");
      panel.className = "bl-static__panel";
      group.nodes.forEach((node) => panel.append(node));

      details.append(summary, panel);
      accordionList.append(details);

      if (tocList) {
        const item = document.createElement("li");
        const link = document.createElement("a");
        link.href = `#${sectionId}`;
        link.textContent = group.title;
        link.addEventListener("click", () => {
          details.open = true;
        });
        item.append(link);
        tocList.append(item);
      }
    });

    source.classList.add("is-enhanced");
    if (toc && groups.length > 1) toc.hidden = false;
    root.dataset.enhanced = "true";
  };

  const init = (scope = document) => {
    scope.querySelectorAll("[data-static-page-hub]").forEach(enhanceStaticPage);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
